<template>
<!--  grid-list-md fluid fill-height-->
  <v-container fluid >
    <PageWrapper :is-loading="preloader">
      <template #title>
        СУТОЧНЫЙ ОТЧЕТ
      </template>
      <template #actions>
        <v-menu
          lazy
          :close-on-content-click="false"
          v-model="menu"
          transition="scale-transition"
          offset-y
          full-width
          :nudge-right="40"
          min-width="290px"
          z-index="100"
        >
          <template v-slot:activator="{ on }">
            <v-btn v-on="on" outline class="daily-date" style="border-radius: 5px">
              {{moment(date).format('DD.MM.YYYY')}}
              <v-icon class="ml-3">calendar_month</v-icon>
            </v-btn>
          </template>
          <v-date-picker
            v-model="date"
            @input="menu = false"
            locale="ru-RU"
            no-title
            scrollable
          >
          </v-date-picker>
        </v-menu>
        <v-btn color="primary" @click="update">Обновить</v-btn>
      </template>
      <v-divider class="mb-2"></v-divider>
      <TableWrapper auto-scroll>
        <v-data-table
          :headers="this.headersFlights"
          :items="flights"
          hide-actions
          class="elevation-0 small-table"
        >
          <template slot="items" slot-scope="props">
            <td
              :rowspan="(getArrayOfObjectsByValueProperty(flights, 'raspName', props.item.raspName)).length"
              v-if="( props.item.id === getArrayOfObjectsByValueProperty(flights, 'raspName', props.item.raspName)[0]['id'])"
              class=""
              :style="{'background-color':getColor(props.item)}"
            >{{ props.item.raspName }}</td>
            <td
              :rowspan="(getFlightsByRaspNameAndType(props.item.raspName, props.item.type)).length"
              v-if="( props.item.id === getFlightsByRaspNameAndType(props.item.raspName, props.item.type)[0]['id'])"
              class=""
              :style="{'background-color':getColor(props.item)}"
            >{{ props.item.type }}</td>
            <td class="" :style="{'background-color':getColor(props.item)}">{{ props.item.to }}</td>
            <td class=" font-weight-bold" :style="{'background-color':getColor(props.item)}">{{ props.item.plan }}</td>
            <td class=" font-weight-bold" :style="{'background-color':getColor(props.item)}">{{ props.item.fact }}</td>
            <td class=" font-weight-bold" :style="{'background-color':getColor(props.item)}">{{ props.item.delayed }}</td>
            <td class=" font-weight-bold" :style="{'background-color':getColor(props.item)}">{{ props.item.liter }}</td>
            <td class=" font-weight-bold" :style="{'background-color':getColor(props.item)}">{{ props.item.canceled }}</td>
          </template>
        </v-data-table>
        <v-divider class="mb-2"></v-divider>
      </TableWrapper>
      <v-divider></v-divider>
      <div class="daily-info pa-3">
        <v-chart
          style="width: 100%; overflow:hidden; min-height: 300px;"
          key="ch1"
          v-if="dailyFlights.bar.series.length"
          :option="dailyFlights.bar"
          autoResize
        />
        <TableWrapper auto-scroll height="245px">
          <v-data-table
            :headers="this.headersPayload"
            :items="payload"
            hide-actions
            class="elevation-0 small-table"
          >
            <template slot="items" slot-scope="props">
              <td>{{ props.item.key }}</td>
              <td class="font-weight-bold">{{ props.item.val }}</td>
            </template>
          </v-data-table>
          <v-divider class="mb-2"></v-divider>

        </TableWrapper>
      </div>
    </PageWrapper>
  </v-container>
</template>

<script>
import store from '@/store'
import Daily from '@/components/modules/Daily'
import PageWrapper from "../ui/PageWrapper.vue";
import moment from "moment";
import TableWrapper from "../ui/TableWrapper.vue";
export default {
  data() {
    return {
      menu: false,
      modal: false,
      headersPayload: [
        {
          text: 'Параметр',
          align: 'left',
          sortable: true,
          value: 'key',
        },
        {
          text: 'Значение',
          align: 'left',
          sortable: true,
          value: 'val',
        },
      ],
      headersFlights: [
        {
          text: 'Вид расписания',
          align: 'left',
          sortable: false,
          value: 'raspName',
        },
        {
          text: 'Тип рейса',
          align: 'left',
          sortable: false,
          value: 'type',
        },
        {
          text: 'Направление',
          align: 'left',
          sortable: false,
          value: 'to',
        },
        {
          text: 'По плану',
          align: 'left',
          sortable: false,
          value: 'plan',
        },
        {
          text: 'По факту',
          align: 'left',
          sortable: false,
          value: 'fact',
        },
        {
          text: 'Задержанные',
          align: 'left',
          sortable: false,
          value: 'delayed',
        },
        {
          text: 'Литерные',
          align: 'left',
          sortable: false,
          value: 'liter',
        },
        {
          text: 'Отмененные',
          align: 'left',
          sortable: false,
          value: 'canceled',
        },
      ],
    }
  },
  computed: {
    payload: {
      get() {
        return store.getters['daily/getDailyPayload']
      },
      set(value) {
        store.commit('daily/setDailyPayload', value)
      },
    },
    flights: {
      get() {
        let flights = store.getters['daily/getDailyFlights']
        let result = []

        for (let keyRaspName in flights) {
          for (let key in flights[keyRaspName]) {
            let item = Object.assign({}, flights[keyRaspName][key])
            if (item['home'] && item['home']['fact']) {
              item['home']['id'] = Math.random()
                .toString(36)
                .substr(2, 15)
              item['home']['type'] = key
              item['home']['raspName'] = keyRaspName
              item['home']['to'] = 'Домашний'

              result.push(item['home'])
            }

            if (item['in'] && item['in']['fact']) {
              item['in']['id'] = Math.random()
                .toString(36)
                .substr(2, 9)
              item['in']['type'] = key
              item['in']['raspName'] = keyRaspName
              item['in']['to'] = 'Прилет'

              result.push(item['in'])
            }

            if (item['out'] && item['out']['fact']) {
              item['out']['id'] = Math.random()
                .toString(36)
                .substr(2, 9)
              item['out']['type'] = key
              item['out']['raspName'] = keyRaspName
              item['out']['to'] = 'Вылет'

              result.push(item['out'])
            }
          }
        }
        return result
      },
      set(value) {
        store.commit('daily/setDailyFlights', value)
      },
    },
    date: {
      get() {
        return store.getters['daily/getDate']
      },
      set(value) {
        store.commit('daily/setDate', value)
      },
    },
    preloader: {
      get() {
        return store.getters['daily/getPreloader']
      },
    },
    dailyFlights: {
      get() {
        let df = store.getters['daily/getDailyFlights'] // data fields

        function sumArrays(array) {
          const n = array.reduce((max, xs) => Math.max(max, xs.length), 0)
          const result = Array.from({ length: n })
          return result.map((_, i) => array.map(xs => xs[i] || 0).reduce((sum, x) => sum + x, 0))
        }
        const  needTotal = this.needTotal
        function ch(param) {
          let obj = {
            bar: {
              title: {
                text: 'Charts',
                x: 'center',
              },
              tooltip: {
                trigger: 'axis',
                axisPointer: {
                  type: 'shadow',
                },
                position: function(point, params, dom, rect, size) {
                  return [point[0], point[1]]
                },
              },
              legend: {
                data: [],
                orient: 'horizontal',
                type: 'scroll',
                bottom: '3%',
                left: '0',
                right: '3%'
              },
              grid: {
                width: '100%',
                top: '3%',
                left: '3%',
                right: '3%',
                bottom: '15%',
                containLabel: true,
              },
              yAxis: {
                type: 'value',
              },
              xAxis: {
                type: 'category',
                data: [],
              },
              color: [
                '#4caf50',
                '#FF9800',
                '#FF5722',
                '#2196f3',
                '#93A9F4',
                '#749f83',
                '#4CAF50',
                '#bda29a',
                '#6e7074',
                '#546570',
                '#c4ccd3',
              ],
              series: [],
            },
          }

          let seriesArray = []
          let seriesResultsArray = []
          let seriesObject = {
            type: 'bar',
            label: {
              normal: {
                show: true,
                position: 'insideRight',
              },
            },
          }
          // df[param.val].forEach(function (item, i, arr) {
          //   obj.bar.legend.data.push((item.type === '') ? 'П' : item.type)
          //   computedData.push(item.plan)
          // })
          for (let keyRaspName in df) {
            for (let key in df[keyRaspName]) {
              let item = df[keyRaspName][key]
              obj.bar.legend.data.push({
                name: `${keyRaspName}/${key}`,
                icon: 'circle',
              })
              seriesObject.name = `${keyRaspName}/${key}`
              seriesObject.stack = 'all' /* dfKey */
              seriesObject.label = {
                show: true,
                position: 'inside',
                formatter: params => params.value || '',
              }
              item['in'] = item['in'] || {}
              item['out'] = item['out'] || {}
              item['home'] = item['home'] || {}

              seriesObject.data = [
                +item['in'][param.val] || 0,
                +item['out'][param.val] || 0,
                +item['home'][param.val] || 0,
              ]
              seriesArray.push(Object.assign({}, seriesObject))
              seriesResultsArray.push(seriesObject.data)
            }
          }

          let sumSeriesResults = sumArrays(seriesResultsArray)

          obj.bar.series = seriesArray
          obj.bar.xAxis.data = [...new Set(obj.bar.xAxis.data)]

          for (let i = 0; i < sumSeriesResults.length; i++) {
            if (sumSeriesResults[i] != 0 && i == 0) {
              obj.bar.xAxis.data.push('Прилет')
            } else if (sumSeriesResults[i] != 0 && i == 1) {
              obj.bar.xAxis.data.push('Вылет')
            } else if (sumSeriesResults[i] != 0 && i == 2) {
              obj.bar.xAxis.data.push('Домашний')
            }
          }
          // if (needTotal) {
            obj.bar.color.unshift('')
            const total = obj.bar.series.reduce((acc, e) => {
              acc[0] += e.data[0]
              acc[1] += e.data[1]
              return acc
            }, [0, 0])
            obj.bar.series.unshift({ name: `Вылет (${total[1]}) / Прилет (${total[0]})`, type: 'bar', stack: 'all' })
            obj.bar.legend.data.unshift({
              name: `Вылет (${total[1]}) / Прилет (${total[0]})`,
            })
          // }
          return obj
        }
        return ch({ val: 'plan' })
      },
      set(value) {
        store.commit('daily/setDailyFlights', value)
      },
    },

  },
  components: {TableWrapper, PageWrapper, Daily },
  methods: {
    moment,
    getColor(item) {
      return item.raspName === 'внутреннее' ? '#F5F5F5' : 'white'
    },
    update: function() {
      store.dispatch('daily/updateDailyFlights', { date: this.date })
      store.dispatch('daily/updateDailyPayload', { date: this.date })
    },
    getArrayOfObjectsByValueProperty(arrayOfObjects, propertyName, propertyValue) {
      let result = arrayOfObjects.filter(obj => {
        return obj[propertyName] === propertyValue
      })

      return result
    },
    getFlightsByRaspNameAndType(raspName, type) {
      let result = this.flights.filter(obj => {
        return obj.raspName === raspName && obj.type === type
      })

      return result
    },
  },
  mounted: function() {
    store.commit('setPageTitle', 'Утренний отчет')
  },
}
</script>
<style scoped>
.daily-date {
  border: 1px solid #8AA1AC;
  border-radius: 5px;
  color: #232323;
  display: flex;
  align-items: center;
  justify-content: space-between;
  i {
    color: #8AA1AC !important;
  }
}
.daily-info {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0 16px;
}
@media (max-width: 968px) {
  .daily-info {
    grid-template-columns: 1fr;
  }
  .chart-mod__lables {
   margin-block: 1rem;
  }
}
@media (min-width: 968px) {
  .chart-mod__lables {
   grid-column: 1;
   grid-row: 2;
  }
}
</style>
